module.exports = __webpack_public_path__ + "static/cafacebookads-053d39f84ab4654cbae0fe0474583d46.png";